import {
  RPC_URL_ANKR,
  RPC_URL_CIRCLES,
  RPC_URL_TENDERLY,
  RPC_URL_GNOSIS,
} from '$lib/constants/rpc';
import { createPublicClient, fallback, http } from 'viem';
import { gnosis, mainnet } from 'viem/chains';

export const publicClient = createPublicClient({
  batch: {
    multicall: true,
  },
  chain: gnosis,
  transport: fallback(
    [http(RPC_URL_TENDERLY), http(RPC_URL_ANKR), http(RPC_URL_CIRCLES), http(RPC_URL_GNOSIS)],
    {
      rank: false,
    },
  ),
});

//Certain viem features like ENS resolution are only available on the mainnet client
export const mainnetClient = createPublicClient({
  chain: mainnet,
  transport: http('https://mainnet.gateway.tenderly.co'),
});
